'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/SettingsButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsButton = exports.SettingsButton = function (_BcReactComponent) {
  _inherits(SettingsButton, _BcReactComponent);

  function SettingsButton() {
    _classCallCheck(this, SettingsButton);

    return _possibleConstructorReturn(this, (SettingsButton.__proto__ || Object.getPrototypeOf(SettingsButton)).apply(this, arguments));
  }

  _createClass(SettingsButton, [{
    key: 'render',
    value: function render() {
      var handleClick = this.props.handleClick;

      return _react2.default.createElement(
        _baseButtons.BlueTextButton,
        {
          className: 'cp-settings-button',
          'data-test-id': 'settings-button',
          handleClick: handleClick },
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_settings_open' })
        ),
        _react2.default.createElement(_baseIcons.Cog, null)
      );
    }
  }]);

  return SettingsButton;
}(_baseBcReactComponent2.default);

SettingsButton.propTypes = {
  handleClick: _react.PropTypes.func.isRequired
};

exports.default = SettingsButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/settings-button/components/SettingsButton.component.js
// module id = 1340
// module chunks = 0